import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import { styled } from 'linaria/react';
import React from 'react';

import { Shortcodes } from '@jetshop/flight-shortcodes';
import Row from '../Shortcodes/Row.js';
import Column from '../Shortcodes/Column.js';
import { Image as ShortcodeImage } from '../Shortcodes/Image';
import TextLink from '../Shortcodes/TextLink';
import CompImage from '../Shortcodes/CompImage';
import ShortcodeContent from '../Shortcodes/Content';
import Intro from '../Shortcodes/Intro';
import AccordionBlock from '../Shortcodes/AccordionBlock';
import Categories from '../Shortcodes/Categories';
import Center from '../Shortcodes/Center';
import ContentAccordion, {
  AccordionItem
} from '../Shortcodes/ContentAccordion';
import CTA from '../Shortcodes/CTA';
import PageLink from '../Shortcodes/PageLink';
import Video from '../Shortcodes/Video';
import { theme } from '../Theme';
import ProductRow from '../Shortcodes/ProductRow';

const StyledBreadcrumbs = styled(Breadcrumbs)`
  max-width: 1288px;
  padding: 0 20px;
  margin: 10px auto;
  text-align: center;
  justify-content: center;
  ${theme.below.lg} {
  }
  li:last-child {
    &:after {
      display: none;
    }
  }
`;

const Content = styled('div')`
  margin: auto;
  display: block;
  width: 100%;
  margin: 0 auto 0 auto;

  ${theme.below.lg} {
    margin-top: 5px;
  }

  h1 {
    font-size: 2.5rem;
    line-height: 0.9;
    margin-bottom: 0.5rem;
  }
  h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  p {
    margin-bottom: 2rem;
  }
  h2,
  h3,
  h4,
  h5 {
    line-height: 0.9;
    ${theme.below.lg} {
      line-height: 1;
    }
  }
`;

function InspirationPage(props) {
  const { category, parents } = props;
  const breadcrumbProps = {
    breadcrumbText: category.breadcrumbText,
    parents
  };
  return (
    <Content>
      <StyledBreadcrumbs {...breadcrumbProps} />
      <Shortcodes
        content={category.content}
        components={{
          Image: ShortcodeImage,
          CompImage: CompImage,
          Row: Row,
          Column: Column,
          TextLink: TextLink,
          Content: ShortcodeContent,
          Intro: Intro,
          AccordionBlock: AccordionBlock,
          ContentAccordion: ContentAccordion,
          AccordionItem: AccordionItem,
          Categories: Categories,
          Center: Center,
          CTA: CTA,
          PageLink: PageLink,
          Video: Video,
          ProductRow: ProductRow
        }}
      />
    </Content>
  );
}

export default InspirationPage;
